// Admins reach any location, so trust their stored selection even before it lands in the active list;
// non-admins keep the membership check so a revoked id can't stick.
export const pickLocationId = (
  locations: ReadonlyArray<{ id: number }>,
  stored: number | undefined,
  isAdmin: boolean,
) => {
  const storedIsValid = stored !== undefined && Number.isInteger(stored) && stored > 0;
  return storedIsValid && (isAdmin || locations.some((l) => l.id === stored)) ? stored : locations[0].id;
};
